export enum PlatformType {
  Web,
  Mobile,
}
